/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateTileDataRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'
import {UpdateTileDataResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'


export const updateTileData = (request:UpdateTileDataRequest, options?: CashRequestOptions) => post<UpdateTileDataRequest, UpdateTileDataResponse>("/2.0/cash/update-tile-data", request, {...options, rejectOnError: true })